export type Resolver = <T>(token: any) => Promise<T>;
